module.exports = __webpack_public_path__ + "pic1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic1.jpg
// module id = 1578
// module chunks = 4